import React from 'react';
import { CardSize, TrainerData, CARDTYPE, isLargeCard, isSmallCard, determineFallbackImg } from '@ifit/mp-card-utilities';
import cx from 'classnames';
import Card from '@ifit/mp-base-card';
import LineWrap from '@ifit/mp-line-wrap';
import ProgressiveBackground from '@ifit/mp-progressive-background';
import { withTranslation, useTranslation } from '@ifit/rapport-webview';
import './index.scss';
import rapportPackage from './rapport-web.json';

export interface ITrainerCardProps {
  data: TrainerData,
  cardSize?: CardSize,
  fallbackImage?: string,
  forceFallbackImg?: boolean,
  themeClass?: string,
}

const TrainerCard = (props: ITrainerCardProps) => {

  const {
    cardSize,
    data,
    forceFallbackImg,
    themeClass,
  } = props;

  const {
    image,
    topWorkoutImages,
    availableWorkouts,
    topCategories,
    name,
  } = data;
  const { _translate } = useTranslation();
  let { fallbackImage } = props;

  if (!fallbackImage) {
    fallbackImage = determineFallbackImg(null, CARDTYPE.TRAINER);
  }

  const small = isSmallCard(cardSize);
  const large = isLargeCard(cardSize);

  const primaryWorkoutImage = topWorkoutImages && topWorkoutImages[0];

  const secondaryWorkoutImage = topWorkoutImages && topWorkoutImages[1];

  const trainerCategoryList = topCategories && topCategories.join(', ');

  const subTitleLineWrap = small ? 2 : 1;

  const trainerWorkoutCount = _translate('%{count} Workout', {
    plural: '%{count} Workouts',
    count: availableWorkouts,
  });

  return (
    <Card
      className={cx('card-template', 'trainer-card', {
        large,
        small,
        themeClass
      })}
    >
      <>
        <div className="thumbnail-container">
          <div className={!small && primaryWorkoutImage && secondaryWorkoutImage ? "workout-images" : "workout-image"}>
            <ProgressiveBackground
              image={!forceFallbackImg ? primaryWorkoutImage : undefined}
              fallbackImage={fallbackImage}
              lazy={{ load: false }}
            />
          </div>
          {!small && secondaryWorkoutImage && (
            <div className="workout-images">
              <ProgressiveBackground
                image={!forceFallbackImg ? secondaryWorkoutImage : undefined}
                fallbackImage={fallbackImage}
                lazy={{ load: false }}
              />
            </div>
          )}
          <div className="trainer-profile">
            <ProgressiveBackground
              image={!forceFallbackImg ? image : undefined}
              fallbackImage={fallbackImage}
              lazy={{ load: false }}
            />
          </div>
        </div>
        <div className="details">
          <LineWrap className="title" maxLines={2} text={name} />
          <LineWrap
            className="teaser"
            maxLines={subTitleLineWrap}
            text={`${trainerWorkoutCount} • ${trainerCategoryList}`}
          />
        </div>
      </>
    </Card>
  );
};

export default withTranslation(rapportPackage)(TrainerCard);
